import { render, staticRenderFns } from "./resultPie.vue?vue&type=template&id=18b50309&lang=pug&"
import script from "./resultPie.vue?vue&type=script&lang=ts&"
export * from "./resultPie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports